<template>
  <draggable :list="form" handle="#drag-zone" item-key="element.name">
    <template #item="{ element }">
      <FormInputCard
        v-if="element.status === ElementStatus.Active"
        :id="element.name"
        :input="element"
        :selected="selectedInput?.name === element.name"
        @click:add="(input) => emit('click:add', input)"
        @click:settings="(input) => emit('click:settings', input)"
        @click:copy="(input) => emit('click:copy', input)"
        @click:delete="(input) => emit('click:delete', input)"
      />
    </template>
  </draggable>
</template>

<script setup lang="ts">
import { inject } from "vue";
import type { Ref } from "vue";
import draggable from "vuedraggable";

import { ElementStatus, FormElement } from "@/@types/entities/forms";

import FormInputCard from "@/app/entities/components/card/FormInputCard.vue";

defineProps<{
  form: FormElement[];
}>();

const emit = defineEmits<{
  (e: "click:add", input: FormElement): void;
  (e: "click:settings", input: FormElement): void;
  (e: "click:copy", input: FormElement): void;
  (e: "click:delete", input: FormElement): void;
}>();

const selectedInput = inject("selectedInput") as Ref<FormElement | undefined>;

// const formActiveElements = computed(() =>
//   props.form.filter((input) => input.status === ElementStatus.Active)
// );
</script>

<style scoped lang="sass">
:deep(.ant-form-item-label)
  padding: 0 !important
</style>
